import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ProgressState {
  value: number | null
}

export const progressSlice = createSlice({
  name: 'progress',
  initialState: { value: null } as ProgressState,
  reducers: {
    setProgress: (state, action: PayloadAction<number | undefined>) => {
      state.value = action?.payload === undefined ? 0 : action.payload
    },
  },
})

export const { setProgress } = progressSlice.actions
